"use strict";

exports.__esModule = true;
var _ProfileContext = require("./ProfileContext");
Object.keys(_ProfileContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfileContext[key]) return;
  exports[key] = _ProfileContext[key];
});
var _ProfileDialog = require("./ProfileDialog");
Object.keys(_ProfileDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfileDialog[key]) return;
  exports[key] = _ProfileDialog[key];
});
var _ProfilePermissionsContext = require("./ProfilePermissionsContext");
Object.keys(_ProfilePermissionsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfilePermissionsContext[key]) return;
  exports[key] = _ProfilePermissionsContext[key];
});